var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('document-list',{attrs:{"config":_vm.config,"isLoading":_vm.isLoading,"height":_vm.height}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }